import { Button } from "@/components/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "@/components/dialog";

interface DeleteDialogProps {
  handleDelete: () => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function DeleteDialog({
  handleDelete,
  open,
  setOpen,
}: DeleteDialogProps) {
  if (open) {
    return (
      <div className="fixed bg-black/30 h-full w-full left-0 top-0 flex justify-center items-center z-[9997]">
        <div className="absolute top-5px bg-white rounded-lg shadow-lg">
          <DialogTrigger>
            <Dialog alert={true}>
              <DialogCloseButton
                aria-label="Close"
                className="cursor-pointer"
                onPress={() => setOpen(false)}
              />
              <DialogHeader>Delete Item</DialogHeader>
              <DialogBody>
                Are you sure you want to delete this item? This action cannot be
                undone.
              </DialogBody>
              <DialogFooter>
                <Button
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                  onPress={() => {
                    handleDelete();
                    setOpen(false);
                  }}
                >
                  Delete
                </Button>
                <Button
                  className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300"
                  onPress={() => setOpen(false)}
                >
                  Cancel
                </Button>
              </DialogFooter>
            </Dialog>
          </DialogTrigger>
        </div>
      </div>
    );
  }
}
